import { FETCH_SERVICE_PORT_CONTACTS_SUCCESS } from "../action/services.action";

const initialState = {
  list: [],
};

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_SERVICE_PORT_CONTACTS_SUCCESS:
      return {
        ...state,
        list: action.payload
      }
    default:
      return state;
  }
}